<template>
  <v-dialog
    v-model="dialog"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="info"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        Show change history
        <v-icon>undo</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2">
        Change History
      </v-card-title>

      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" nowrap>
                  Date/Time
                </th>
                <th class="text-left">
                  Diff
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in histories">
                <tr
                  v-for="(op, i) in item.ops"
                  :key="`${item._id}_${i}`"
                >
                  <td nowrap v-if="i === 0" :rowspan="item.ops.length">{{ item.date | formatDateTime }}</td>
                  <td>
                    <template v-if="op.op === 'add'">
                      <code>{{ op.path }}</code>&nbsp;was added with value&nbsp;<code>{{ op.value }}</code>
                    </template>
                    <template v-else-if="op.op === 'remove'">
                      <code>{{ op.path }}</code>&nbsp;was removed
                    </template>
                    <template v-else-if="op.op === 'replace'">
                      <code>{{ op.path }}</code>&nbsp;was replaced with value&nbsp;<code>{{ op.value }}</code>
                    </template>
                    <template v-else>
                      {{ op }}
                    </template>
                  </td>
                </tr>
              </template>

            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'HistoryDialog',

  props: {
    model: {
      type: String,
      required: true
    },
    _id: {
      type: String,
      required: true
    }
  },

  data: () => ({
    dialog: false,
    histories: []
  }),

  apollo: {
    histories: {
      query: gql`query GetHistory($model: String!, $_id: MongoID!) {
        histories: adminFindHistory(model: $model, _id: $_id) {
          _id
          date
          ops {
            path
            op
            value
          }
        }
      }`,
      variables () {
        return {
          model: this.model,
          _id: this._id
        }
      }
    }
  },

  watch: {
    dialog (val) {
      if (val) this.$apollo.queries.histories.refresh()
    }
  }
}
</script>
